module.exports = __webpack_public_path__ + "assets/img/004.43c9ae5b.jpg";